import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=6717992c&"
import script from "./Pickup.vue?vue&type=script&lang=js&"
export * from "./Pickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports